<div class="page">
  <div class="header">
    <h1 class="header-title">
      <mat-icon>delete</mat-icon>
      <div>Prullenbak</div>
    </h1>
    <button mat-raised-button [class.spinner]="exporting()" [disabled]="exporting()" (click)="exportDeletedRides()">
      <mat-icon>file_download</mat-icon>
      Export
    </button>
  </div>
  <mat-card class="content">
    @if (loaded()) {
      <div role="region" aria-labelledby="deleted-rides-title">
        <div class="content-header">
          <h2 id="deleted-rides-title">Verwijderde ritten ({{ filteredDeletedRides().length ?? 0 }})</h2>
          <form [formGroup]="filterForm" class="header-right">
            <mat-form-field class="mat-form-field-no-subscript">
              <mat-label class="search-label">Zoek in</mat-label>
              <mat-select formControlName="searchOn" (selectionChange)="searchFilter()" cdkFocusInitial>
                <mat-option value="all">Alles</mat-option>
                <mat-option value="start">Rit datum</mat-option>
                <mat-option value="vehicle">Voertuig</mat-option>
                <mat-option value="user">Passagier</mat-option>
                <mat-option value="doneByUser">Verwijderd door</mat-option>
                <mat-option value="deleteReason">Reden van verwijderen</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="mat-form-field-no-subscript">
              <mat-label class="search-label">Zoeken</mat-label>
              <input matInput placeholder="Zoeken" autocomplete="off" formControlName="search" />
              <button
                mat-icon-button
                matSuffix
                [disableRipple]="true"
                aria-label="Zoekopdracht wissen"
                (click)="clearSearch(); $event.stopPropagation()"
              >
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>
          </form>
        </div>
        <form class="filters" [formGroup]="dateForm">
          <mat-form-field class="mat-form-field-no-subscript">
            <mat-label>Selecteer filter</mat-label>
            <mat-select (selectionChange)="periodFilter()" formControlName="selectedDateFilter">
              @for (filter of dateFilter; track filter) {
                <mat-option [value]="filter.value">
                  {{ filter.viewValue }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field class="mat-form-field-no-subscript">
            <mat-label>Jaar</mat-label>
            <mat-select (selectionChange)="periodFilter()" formControlName="selectedYear">
              @for (year of years(); track year) {
                <mat-option [value]="year.value">{{ year.viewValue }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
          @if (dateForm.value.selectedDateFilter == 'month') {
            <mat-form-field class="mat-form-field-no-subscript">
              <mat-label>Maand</mat-label>
              <mat-select (selectionChange)="periodFilter()" formControlName="selectedMonth">
                @for (month of months; track month) {
                  <mat-option [value]="month.value">{{ month.viewValue }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (dateForm.value.selectedDateFilter == 'week') {
            <mat-form-field class="mat-form-field-no-subscript">
              <mat-label>Week</mat-label>
              <mat-select (selectionChange)="periodFilter()" formControlName="selectedWeek">
                @for (week of weekArray; track week) {
                  <mat-option [value]="week">{{ week }} </mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
        </form>
        <div class="list-items">
          <div class="list-item-wrapper headers">
            <div class="list-item-col-wrapper">
              <div class="list-item-col">
                Ritdatum
                <button
                  mat-icon-button
                  (click)="sortColumn('ridestart')"
                  aria-label="Sorteren omdraaien"
                  matTooltip="Sorteren omdraaien"
                  [disableRipple]="true"
                >
                  @if (orderDirection() == 'asc' && sortByColumn() == 'ridestart') {
                    <mat-icon> arrow_upward </mat-icon>
                  }
                  @if (orderDirection() == 'desc' && sortByColumn() == 'ridestart') {
                    <mat-icon> arrow_downward </mat-icon>
                  }
                  @if (sortByColumn() != 'ridestart') {
                    <mat-icon> compare_arrows </mat-icon>
                  }
                </button>
              </div>
              <div class="list-item-col unimportant2">Voertuig</div>
              <div class="list-item-col">
                Verwijderd op
                <button
                  mat-icon-button
                  (click)="sortColumn('date')"
                  aria-label="Sorteren omdraaien"
                  matTooltip="Sorteren omdraaien"
                  [disableRipple]="true"
                >
                  @if (orderDirection() == 'asc' && sortByColumn() == 'date') {
                    <mat-icon> arrow_upward </mat-icon>
                  }
                  @if (orderDirection() == 'desc' && sortByColumn() == 'date') {
                    <mat-icon> arrow_downward </mat-icon>
                  }
                  @if (sortByColumn() != 'date') {
                    <mat-icon> compare_arrows </mat-icon>
                  }
                </button>
              </div>
              <div class="list-item-col unimportant3">Verwijderd door</div>
              <div class="list-item-col unimportant">Reden van verwijderen</div>
              <div class="list-item-col"></div>
            </div>
          </div>
          <cdk-virtual-scroll-viewport itemSize="50px" class="list-wrapper">
            @for (deletedRide of filteredDeletedRides(); track deletedRide.id) {
              <div
                class="list-item-wrapper"
                role="button"
                tabindex="0"
                aria-label="Verwijderde rit openen"
                (click)="moreInformationDeletedRide(deletedRide)"
                (keydown.enter)="moreInformationDeletedRide(deletedRide)"
                (keydown.space)="$event.preventDefault(); moreInformationDeletedRide(deletedRide)"
              >
                <div class="list-item-col-wrapper">
                  <div class="list-item-col">
                    {{ moment(deletedRide.rideData.start.toDate()).format('DD-MM-YYYY HH:mm uur') ?? '' }}
                  </div>
                  <div class="list-item-col unimportant2">
                    {{ getVehicleName(deletedRide.rideData.vehicleId) ?? '' }}
                  </div>
                  <div class="list-item-col">
                    {{ moment(deletedRide.date.toDate()).format('DD-MM-YYYY') ?? '' }}
                  </div>
                  <div class="list-item-col unimportant3">
                    {{ deletedRide.doneByUser ?? '' }}
                  </div>
                  <div class="list-item-col unimportant">
                    {{ deletedRide.deleteReason ?? '' }}
                  </div>
                  <div class="list-item-col">
                    <div class="list-item-buttons">
                      <button mat-icon-button aria-label="Verwijderde rit bekijken">
                        <mat-icon>visibility</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
    }
    @if (!loaded() || loadingRides()) {
      <div
        class="loading-wrapper"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        [class.loading-rides]="loadingRides()"
      >
        <div class="loading">
          <mat-spinner></mat-spinner>
        </div>
      </div>
    }
  </mat-card>
</div>
